import './index.scss';
import { Application, Controller } from 'utils/stimulus';
import { MediaQuery } from 'utils/media_query';

export class HeaderMobileMenu extends Controller {
  static targets = [
    'categorySelector',
    'categoryList',
    'primaryLinks',
    'secondaryLinks',
    'expandButton'
  ];

  isCategorySelectorOpen = false;
  isExpandContainerOpen = false;

  currentCategoryKey = 'concursos';
  categories = ['concursos', 'militares', 'oab', 'enem', 'vestibular'];

  connect() {
    this.setupClickEvents();
    this.renderCategorySelector();
    this.renderLinks();

    this.setupAmplitudeEvents();
  }

  setupAmplitudeEvents() {
    const $playgroundCta = $('#playgroundMobileCtaHeader');
    const $eliteCta = $('#eliteMobileCtaHeader');

    $playgroundCta.on('click', () => {
      UserTracker.emit('event', {
        eventName: 'mesa button clicked',
        data: {
          'click source': 'portal - mobile menu'
        }
      });
    });

    $eliteCta.on('click', () => {
      UserTracker.emit('event', {
        eventName: 'elite button clicked',
        data: {
          'click source': 'portal - mobile menu'
        }
      });
    });
  }

  setupClickEvents() {
    // Open/Close menu
    $(document)
      .off('change.segments-toggle-input')
      .on('change.segments-toggle-input', '#segments-toggle-input', e => {
        const $context = $('.q-segments-menu--mobile');

        if (!$context.length) {
          return;
        }

        if (MediaQuery.is('lt_header_lg_breakpoint')) {
          const $body = $('body');
          const { checked } = e.currentTarget;

          if (checked) {
            $('#user-menu-mobile-toggle-input').prop('checked', !checked);
            $body.addClass('q-no-scroll q-mobile-menu-open');
          } else {
            $body.removeClass('q-no-scroll q-mobile-menu-open');
          }
        }
      });

    // Open/Close category selector
    $(this.categorySelectorTarget).on('click', () => {
      this.toggleCategorySelector();
    });

    // Select category on category selector
    $(this.categoryListTarget).on('click', event => {
      this.handleCategorySelection(event.target);
    });

    // Open/Close expand container
    $(this.expandButtonTarget).on('click', () => {
      this.toggleExpandContainer();
    });
  }

  toggleCategorySelector() {
    const $elem = $(this.categorySelectorTarget).parent();
    const className = 'category-selector--open';

    if (this.isCategorySelectorOpen) {
      $elem.removeClass(className);
    } else {
      $elem.addClass(className);
    }

    this.isCategorySelectorOpen = !this.isCategorySelectorOpen;
  }

  toggleExpandContainer() {
    const $elem = $(this.expandButtonTarget).parent();
    const $text = $(this.expandButtonTarget).find('span');
    const className = 'expand-container--open';

    if (this.isExpandContainerOpen) {
      $elem.removeClass(className);
      $text.text('Ver mais');
    } else {
      $elem.addClass(className);
      $text.text('Ver menos');
    }

    this.isExpandContainerOpen = !this.isExpandContainerOpen;
  }

  handleCategorySelection(element) {
    if (element.tagName !== 'LI') {
      return;
    }

    this.currentCategoryKey = element.dataset.key;

    this.toggleCategorySelector();

    if (this.isExpandContainerOpen) {
      this.toggleExpandContainer();
    }

    this.renderCategorySelector();
    this.renderLinks();
  }

  renderCategorySelector() {
    $(this.categorySelectorTarget)
      .find('span')
      .text(this.currentCategoryKey.toUpperCase());

    this.categorySelectorTarget.dataset.selected = this.currentCategoryKey;

    this.categoryListTarget.innerHTML = this.categories
      .filter(key => key !== this.currentCategoryKey)
      .map(key => `<li data-key="${key}">${key.toUpperCase()}</li>`)
      .join('');
  }

  renderLinks() {
    const $elem = $(this.element);

    $elem.find('.primary-links--show').removeClass('primary-links--show');
    $elem.find('.secondary-links--show').removeClass('secondary-links--show');

    $elem
      .find(`.primary-links--${this.currentCategoryKey}`)
      .addClass('primary-links--show');

    $elem
      .find(`.secondary-links--${this.currentCategoryKey}`)
      .addClass('secondary-links--show');
  }
}

global.HeaderMobileMenuApplication =
  global.HeaderMobileMenuApplication || Application.start();
global.HeaderMobileMenuApplication.register(
  'q-segments-menu-mobile',
  HeaderMobileMenu
);
